<template>
    <div class="mainBox">
        <div class="topBox line_bottom">
            <h5>诚信指数</h5>
            <p>{{scoreData}}<span>分</span></p>
        </div>
        <div id="SincerityIndexRadar" class="SincerityIndexRadar">
            <div class="index container">
                <div class="echarts-contain">
                    <div :id="id" class="o-echarts"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import echarts from 'echarts';
    export default {
        name: 'SincerityIndexRadar',
        props: {
            'radarData': Array,
            scoreData: {
                type: String,
                default: null
            }
        },
        data () {
            return {
                id: 'echarts_' + new Date().getTime() + Math.floor(Math.random() * 1000),
                echartObj: null,
                option: {
                    center: ['50%', '50%'],
                    radius: '10%',
                    tooltip: {
                        show: false
                    },
                    radar: {},
                    series: {},
                }
            };
        },
        mounted () {
            this.echartObj = echarts.init(document.getElementById(this.id));
            // echarts.registerMap('yunnan', JSON);
            this.echartObj.setOption(this.setSeriesData(), true);
        },
        computed: {
        },
        watch: {
            radarData: {
                handler (newValue, oldValue) {
                    for (let i = 0; i < newValue.length; i++) {
                        if (oldValue[i] !== newValue[i]) {
                            this.echartObj.setOption(this.setSeriesData(), true);
                        }
                    }
                },
                deep: true
            }
        },
        methods: {
            getXaxisData () {
                // 填入value
                if (this.radarData.length > 0) {
                    return this.radarData.map(item => {
                        return item.value
                    });
                }
            },
            getSeriesData () {
                // 填入数据
                console.log('this.radarData:', this.radarData)
                return this.radarData
            },
            setSeriesData () {
                var arr1 = this.getXaxisData();
                var i = -1;
                this.setOptions('radar', (() => {
                    return {
                        name: {
                            rich: {
                                a: {
                                    color: '#666',
                                    fontSize: 10,
                                    fontWeight:500
                                },
                                b: {
                                    color: '#36B374',
                                    align: 'center',
                                    backgroundColor: 'rgba(255,255,255,0)',
                                    padding: 4
                                }
                            },
                            formatter: (a, b) => {
                                i++;
                                if(i==0){
                                    return `{b|${arr1[i]}}\n{a|${a}}`
                                }else{
                                    return `{a|${a}}\n{b|${arr1[i]}}`
                                }
                                
                            },
                            
                        },
                        indicator: this.getSeriesData(),
                        splitLine: {
                            show: true
                        },
                        splitArea: {
                            show: true,
                            areaStyle: {
                                color: '#fff'
                            }
                        },
                        splitNumber: 2, // 雷达图圈数设置
                        radius: 60 //缩放图列解决label被挡住
                    }
                })());
                this.setOptions('series', (() => {
                    return {
                        name: '指数',
                        type: 'radar',
                        label: {
                            show: false
                        },
                        areaStyle: {
                            normal: {
                                color: 'rgba(207,237,221,1)' // 选中区域颜色
                            }
                        },
                        lineStyle: {
                            normal: {
                                color: '#36B374' // 线条颜色
                            }
                        },
                        itemStyle: {
                            normal: {
                                color: '#36B374', // 线条颜色
                                opacity: 0
                            }
                        },
                        data: [
                            {
                                value: this.getXaxisData(),
                                name: '指数'
                            }
                        ]
                    }
                })());
                return this.option;
            },
            setOptions (objKey, objVal) {
                if (this.option[objKey] && typeof this.option[objKey] === 'object' && !Array.isArray(this.option[objKey])) {
                    this.option[objKey] = Object.assign(this.option[objKey], objVal);
                } else {
                    this.option[objKey] = objVal;
                }
                this.$set(this.option, objKey, this.option[objKey]);
            }
        }
    }
</script>

<style lang="less" scoped>
    .mainBox{
        width: 100%;
        background-color: #fff;
        padding-bottom: 10px;
        .topBox{
            padding-top: 22px;
            padding-bottom: 24px;
            font-weight:500;
            text-align: center;
            height: 90px;
            // border: 1px solid #eeeeee;
            >h5{
                margin-bottom: 11px;
                font-size: 12px;
                font-weight:400;
                text-align: center;
                line-height: 12px;
            }

            >p{
                font-size: 32px;
                font-weight: bold;
                vertical-align: top;
                color: #36B374;
                display: inline-block;
                text-align: center;
                position: relative;

                >span{
                    position: absolute;
                    float: left;
                    margin-left: 4px;
                    display: inline-block;
                    font-weight: normal;
                    font-size: 10px;
                    bottom: 5px;
                }
            }
        }

        .SincerityIndexRadar{
            z-index: 999;
            height: 210px;
            margin-top: 5px;
            margin-bottom: -50px;
            .container{
                width: 100%;
                height: 100%;
                padding: 0 12px;
                .echarts-contain{
                    width: 100%;
                    height: 100%;
                    .o-echarts {
                        width: 100%;
                        height: 100%;
                    }
                }
            }
        }
    }
</style>
